const textareas = document.querySelectorAll<HTMLTextAreaElement>(
	'textarea[maxlength]',
);

// Show a character counter on textareas with a maximum length.
for (const textarea of textareas) {
	const {maxLength, nextElementSibling: counter} = textarea;

	textarea.addEventListener('keypress', (event) => {
		const {
			value: {length},
		} = textarea;
		if (length > maxLength) {
			event.preventDefault();
		}
	});

	textarea.addEventListener('keyup', () => {
		const {
			value: {length},
		} = textarea;
		if (counter instanceof HTMLDataElement) {
			counter.setAttribute('value', String(length));
			counter.textContent = `${length}/${maxLength}`;
			counter.classList.toggle('counter-max', length >= maxLength);
		}
	});
}
